module.exports = __webpack_public_path__ + "static/uniacces-06739abce1b0e411cf20df4d2a95e4d7.png";